import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import LinkBox from './link-box';
import homeIcon from '../../assets/images/home.svg';
import profileIcon from '../../assets/images/profil.svg';
import courseIcon from '../../assets/images/course.svg';
import newsIcon from '../../assets/images/news.svg';
import { useLocation } from 'react-router-dom';


const styles = (theme) => ({
  root: {},
  stickToBottom: {
    boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.05)",
    background: '#F2F4FA',
    width: "calc(100% - 20px)",
    zIndex: 102,
    minHeight: 75,
    position: "fixed",
    bottom: 0,
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 10,
    paddingTop: 5,
    paddingLeft: 10,
    paddingRight: 10,  
  },
  icons: {
    height: 30,
  },

  navAction: {
    '&.Mui-selected': {
      backgroundColor: '#D6EAF8',
      borderRadius: '12px',
    }
  },
  linkBox: {},
});

const Footer = withStyles(styles)(({ classes }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  return (
    <div
      className="footer"
    >
      <BottomNavigation className={classes.stickToBottom} value={currentPath} >
        <BottomNavigationAction
          value="/"
          to="/"
          component={Link}
          className={classes.navAction}
          icon={<LinkBox icon={homeIcon} text="Home"/>}
        />
        <BottomNavigationAction
          value="/courses"
          to="/courses"
          component={Link}
          className={classes.navAction}
          icon={<LinkBox icon={courseIcon} text="Wissen"/>}
        />
        <BottomNavigationAction
          component={Link}
          to="/news"
          value="/news"
          className={classes.navAction}
          icon={<LinkBox icon={newsIcon} text="News"/>}
        />
        <BottomNavigationAction
          component={Link}
          to="/profile"
          value="/profile"
          className={classes.navAction}
          icon={<LinkBox icon={profileIcon} text="Profil"/>}
        />
      </BottomNavigation>
    </div>
  );
  });

export default withRouter((props) => <Footer {...props} />);
